import React from 'react';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class Report extends React.Component {

  state = {
    data: [],
    maxWidth: 'ms',
    fullWidth: true,
    detailReport: []
  }

  componentDidMount() {
    this.getToday();
  }

  getToday() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if(dd<10){
      dd='0'+dd
    }
    if(mm<10){
        mm='0'+mm
    }
    today = yyyy+'-'+mm+'-'+dd;
    this.setState({ date: today })
    this.getReport(today);
  }

  onChnageHandle = (type) => event => {
    this.setState({ [type]: event.target.value })
    this.getReport(event.target.value);
  }

  getReport(today) {
    let context = this;
    $.ajax({
      type: 'POST',
      data: { 'date': today },
      url: Server() + 'sms/report.php',
      success: function(data)
      {
        context.setState({
          load: false
        });
        try {
          data = JSON.parse(data);
          context.setState({ data: data })
        } catch (e) {
          alert('Error!!!')
        }

      },
      error: function(err)
      {
        context.setState({
          load: false,
        })
      }
    })
  }

  view(msg) {
    let context = this;
    let date = this.state.date;
    $.ajax({
      type: 'POST',
      data: { 'date': date, 'msg': msg },
      url: Server() + 'sms/detailreport.php',
      success: function(data)
      {
        context.setState({
          load: false
        });
        try {
          data = JSON.parse(data);
          context.setState({ detailReport: data, dialog: true })
        } catch (e) {
          alert('Error!!!')
        }

      },
      error: function(err)
      {
        context.setState({
          load: false,
        })
      }
    })
  }

  render() {
    let i = 0;
    let j = 0;
    return (
      <div style={{padding: '2%', display: this.props.viewcontrol}}>
        <Loading load={this.state.load} message={'Getting Report!!!'} />
        <input type='date' value={this.state.date} onChange={this.onChnageHandle('date')} />
        <br/><br/>
        { this.state.data.length > 0 ?
          (
            <table id='table' width='100%'>
              <tr>
                <th id='th' style={{width: '10%'}}><center>Sino</center></th>
                <th id='th' style={{width: '80%'}}><center>Message</center></th>
                <th id='th'  style={{width: '10%'}}><center>Count</center></th>
              </tr>
              { this.state.data.map((c) => {
                  i++;
                  return (
                    <tr id='tbody'>
                      <td id='pointer' onClick={this.view.bind(this, c.msg)}><center>{i}</center></td>
                      <td id='pointer' onClick={this.view.bind(this, c.msg)}>{c.msg}</td>
                      <td id='pointer' onClick={this.view.bind(this, c.msg)}><center>{c.count}</center></td>
                    </tr>
                  )
                })
              }
            </table>
          ) :
          (
            <div></div>
          )
        }

        <React.Fragment>
          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth}  open={this.state.dialog}
            onClose={ () => { this.setState({ dialog: false }) }} aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Add Request</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <table id='table' width="100%">
                  <tr style={{height: 10}}>
                    <th id='th'><center>Sino</center></th>
                    <th id='th'><center>Customer</center></th>
                    <th id='th'><center>Timestamp</center></th>
                  </tr>
                  { this.state.detailReport.map((c) => {
                      j++;
                      return (
                        <tr id='tbody'>
                          <td><center>{j}</center></td>
                          <td><center>{c.cid+'->'+c.name}</center></td>
                          <td><center>{c.timestamp}</center></td>
                        </tr>
                      )
                    })
                  }
                </table>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={ () => { this.setState({ dialog: false }) }}>Close</Button>
            </DialogActions>
          </Dialog>
        </React.Fragment>
      </div>
    );
  }
}

export default Report;
